module.exports = __webpack_public_path__ + "assets/cta-decoration-bl.ce94e93c.png";